import React from 'react';
import { Form, Col, Row, Button, Navbar, Container, Image, Spinner} from 'react-bootstrap';
import axios from 'axios';
import { Constants } from "../../constants";
import 'bootstrap/dist/css/bootstrap.min.css';

class PasswordResetRequest extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            value: '',
            loading: false,
            error: null
        };

        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showButton = this.showButton.bind(this);
    }

    handleEmailChange(event) {
        this.setState({ email: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({ loading: true },
            () => {
                axios.post(`${Constants.apiURL}/api/Identity/RequestPasswordReset`, null, {
                    params: {
                        email: this.state.email
                    }
                }).then(response => {
                    this.setState({ loading: false });
                    alert('Email sent.');
                }).catch((response) => {
                    // ? Show to user that request is failed
                    this.setState({ error: 'Error connecting to server.', loading: false });
                    console.log('request failed', response)
                });
            });
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginTop: '5px', backgroundColor: '#1F419B', width: '80px' }} variant="primary" disabled>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>;
        }
        else {
            return <Button style={{ marginTop: '5px', backgroundColor: '#1F419B', width: '80px' }} variant="primary" type="submit">
                Submit
            </Button>;
        }
    }

    render() {
        const customStyle = {
            padding: '10px',
            margin: '10px',
            maxWidth: '480px'
        };
        return (
            <div>
                <Navbar className="boland-navbar" collapseOnSelect expand="md" defaultExpanded sticky="top">
                    <Container style={{ marginLeft: '0px' }}>
                        <Navbar.Brand style={{ margin: 0, padding: 0, color: '#FFFFFF' }}>
                            <Image src="./Boland block 2.png" width="165px" height="40px" />{' '}
                        </Navbar.Brand>
                        <Navbar.Collapse>
                            <Navbar.Text style={{ color: '#FFFFFF', paddingLeft: '30px', fontSize: '18px' }}>
                                Welcome to our client portal.
                            </Navbar.Text>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                <Form style={customStyle} onSubmit={this.handleSubmit}>
                    <Row>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="email" placeholder="Enter email" onChange={this.handleEmailChange} />
                            </Form.Group>
                            {this.showButton()}
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

export default PasswordResetRequest;